import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import userService from '../services/userService';
import { validateVendorProfileCompleteness } from '../utils/validationUtils';

const VendorProfileCheck = () => {
  const { user } = useAuth();
  const [isComplete, setIsComplete] = useState(true);
  
  useEffect(() => {
    if (user?.role === 'vendor') {
      const checkProfile = async () => {
        try {
          const response = await userService.getVendorProfile();
          
          if (response.success) {
            const profileData = response.data?.vendorProfile || response.data || {};
            
            // ✅ FIX: Extract isComplete property from validation result
            const validation = validateVendorProfileCompleteness(profileData);
            
            // Handle both boolean and object return types for backward compatibility
            const completeness = typeof validation === 'boolean' 
              ? validation 
              : validation.isComplete;
            
            setIsComplete(completeness);
          } else {
            setIsComplete(false);
          }
        } catch (error) {
          console.error('Error checking profile:', error);
          setIsComplete(false);
        }
      };
      
      checkProfile();
    }
  }, [user]);

  if (user?.role !== 'vendor' || isComplete) {
    return null;
  }

  return (
    <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-6">
      <div className="flex">
        <div className="flex-shrink-0">
          <svg className="h-5 w-5 text-yellow-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
          </svg>
        </div>
        <div className="ml-3">
          <h3 className="text-sm font-medium text-yellow-800">Incomplete Profile</h3>
          <div className="mt-2 text-sm text-yellow-700">
            <p>
              Your vendor profile is incomplete. Contact information and pickup address are required for Terminal delivery integration. Without this information, order pickup scheduling will fail.
            </p>
          </div>
          <div className="mt-3">
            <Link 
              to="/vendor/profile" 
              className="text-sm font-medium text-yellow-800 hover:text-yellow-700 underline"
            >
              Complete your profile →
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VendorProfileCheck;